import React from "react";
import styled from "styled-components";

import { useCartContext } from "../context/CartContext";
import { formatPrice } from "../utils/helpers";
import ActionButton from "./ActionButton";
import Card from "./Card";

interface PriceItemProps {
  bold?: boolean;
}

const PaymentSummary = (props: any) => {
  const { className } = props;

  const { totalAmount } = useCartContext();

  const shipping = 0;
  const tax = totalAmount * 0.09;
  const total = totalAmount + shipping + tax;

  return (
    <Wrapper>
      <Card className={"paymentCard"} title={"Payment Summary"} color={"#FFF"}>
        <div className={className}>
          <PriceItem>
            <p>Subtotal</p>
            <p>{formatPrice(totalAmount)}</p>
          </PriceItem>
          <PriceItem>
            <p>Estimated Shipping</p>
            <p>{formatPrice(shipping)}</p>
          </PriceItem>
          <PriceItem>
            <p>Estimated Tax</p>
            <p>{formatPrice(tax)}</p>
          </PriceItem>
          <Line />
          <PriceItem bold>
            <p>Total</p>
            <p>{formatPrice(total)}</p>
          </PriceItem>
          <Line />
          <ActionButton
            className={"checkoutBtn"}
            height={46}
            color={"#000"}
            label="Checkout"
          />
        </div>
      </Card>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  min-width: 300px;

  .checkoutBtn {
    width: 100%;
    font-size: 16px;
    margin: 0.6rem 0;
  }

  .paymentCard {
    height: 100%;
  }
`;

const Line = styled.hr`
  display: block;
  height: 1px;
  border: 0;
  border-top: 1px solid #d8d8d8;
  margin-bottom: 18px;
  padding: 0;
`;

const PriceItem = styled.div<PriceItemProps>`
  display: flex;
  justify-content: space-between;
  font-family: ${(p) =>
    `${p.bold ? "HelveticaNeue-Bold" : "HelveticaNeue-Medium"}`};
  p {
    margin-top: 0;
    margin-bottom: 18px;
  }
`;

export default PaymentSummary;
